import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ConnectionIcon from 'components/icons/ConnectionIcon'
import CandidateDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/Components/CandidateDetails'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/ManyToManyPreview/style'
import moment from 'moment'
import React, { Fragment } from 'react'
import {
  AdjustIcon,
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeNameDiv,
  ContentDiv,
  DetailsNameDiv,
  DetailsTitleDiv,
  InterviwerFlex,
  LeftFlex,
  LinkSpan,
  MainFlex,
  RightFlex,
} from '../OneToOnePreview/style'
import ScheduledSuccessfully from '../ScheduledSuccessfully/index'

const ScheduleDetails = ({
  interviewType,
  interviewInfo,
  isSingleOrBulk = true,

  selectedCandidate,

  setPrivew,
  scheduleInterview,
  setCreateSlotDrawer,
  preview,

  isLoading,
  candidateInfoData,
  setInterviewType,

  count,
  isBulk,
  interviewRoundInfo,
  success,
  setSuccess,
  setNotification,
  setCandidateInfo,
  selectedRoundType,
  interviewValueInfo,
  dateArr,
}) => {
  const handleConfirm = async () => {
    let response = await scheduleInterview(true, interviewInfo)
    if (response) {
      setInterviewType(false)
      setSuccess(true)
    }
  }
  const handleBack = () => {
    setCreateSlotDrawer(true)
    setPrivew(false)
  }

  const firstTime =
    interviewInfo?.timeRange?.[0] || interviewRoundInfo?.timeRange?.[0] // First element
  const lastTime =
    interviewInfo?.timeRange?.[interviewInfo?.timeRange?.length - 1] ||
    interviewRoundInfo?.timeRange?.[interviewRoundInfo?.timeRange?.length - 1]
  const content = () => {
    return (
      <>
        {(interviewRoundInfo?.interview?.interviewType == 'ASSESMENT' ||
          interviewRoundInfo?.interview?.interviewType ==
            'EXTERNAL_ASSESMENT') && (
          <>
            {isSingleOrBulk && (
              <CandidateDetails
                selectedCandidate={selectedCandidate}
                count={count}
                isBulk={isBulk}
              />
            )}
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Round Name</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.interview?.interviewRound}{' '}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Round Type</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.interview?.interviewType ===
                  'FACE_TO_FACE'
                    ? 'Face to Face'
                    : interviewRoundInfo?.interview?.interviewType === 'GROUP'
                    ? 'Group Discussion'
                    : interviewRoundInfo.interview?.interviewType.toLowerCase()}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Date Scheduled</DetailsNameDiv>
                <ContentDiv>
                  {dateArr?.map((item, index) => (
                    <span
                      key={index + 'dateShowing'}
                      style={{
                        backgroundColor: ' #f0f0f0',
                        padding: '5px 5px', // Adjust padding as needed
                        borderRadius: '5px', // Adjust border radius as needed
                        marginRight:
                          index !== dateArr?.length - 1 ? '5px' : '0',
                      }}
                    >
                      {moment(item).format('DD MMM, YYYY')}
                    </span>
                  ))}
                </ContentDiv>
              </LeftFlex>
              {interviewInfo?.timeRange && (
                <LeftFlex>
                  <DetailsNameDiv>Time</DetailsNameDiv>
                  <ContentDiv>{firstTime + ' - ' + lastTime}</ContentDiv>
                </LeftFlex>
              )}
              {interviewInfo?.duration ? (
                <LeftFlex>
                  <DetailsNameDiv>Duration</DetailsNameDiv>
                  <ContentDiv>{interviewInfo?.duration} Mins</ContentDiv>
                </LeftFlex>
              ) : (
                <LeftFlex>
                  <DetailsNameDiv>Duration</DetailsNameDiv>
                  <ContentDiv>{interviewRoundInfo?.duration} Mins</ContentDiv>
                </LeftFlex>
              )}
              <LeftFlex>
                <DetailsNameDiv>Interview type</DetailsNameDiv>{' '}
                <ContentDiv>
                  {interviewRoundInfo.interview?.interviewType.toLowerCase()}
                </ContentDiv>
              </LeftFlex>
              {interviewInfo ? (
                <LeftFlex>
                  <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                      ? 'Google Meet'
                      : interviewInfo?.mode === 'OFFLINE'
                      ? interviewInfo?.mode?.toLowerCase()
                      : 'External Link'}
                  </ContentDiv>
                </LeftFlex>
              ) : (
                <LeftFlex>
                  <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                  <ContentDiv>
                    {interviewRoundInfo?.mode === 'EXTERNAL_LINK_1'
                      ? 'Google Meet'
                      : interviewRoundInfo?.mode === 'OFFLINE'
                      ? interviewRoundInfo?.mode?.toLowerCase()
                      : 'External Link'}
                  </ContentDiv>
                </LeftFlex>
              )}
              {interviewInfo?.linkAndPanel?.[0]?.link ? (
                <LeftFlex>
                  <DetailsNameDiv>Link</DetailsNameDiv>
                  <ContentDiv noCap>
                    <LinkSpan
                      href={interviewInfo?.linkAndPanel?.[0]?.link}
                      target="_blank"
                    >
                      {interviewInfo?.linkAndPanel?.[0]?.link || '-'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              ) : (
                <LeftFlex>
                  <DetailsNameDiv>Link</DetailsNameDiv>
                  <ContentDiv noCap>
                    <LinkSpan href={interviewRoundInfo?.link} target="_blank">
                      {interviewRoundInfo?.link || '-'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Interviewer</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.panel?.map((data, kIndex) => {
                    return (
                      <CollageDetailsFlex
                        spaceBetween
                        centerVertically
                        key={kIndex + 'avatar'}
                      >
                        <Flex alignCenter>
                          <AntdAvatar size={36} src={data?.profilePicture} />
                        </Flex>
                      </CollageDetailsFlex>
                    )
                  })}
                </ContentDiv>
              </LeftFlex>
              {interviewInfo?.location && (
                <LeftFlex>
                  <DetailsNameDiv>Location</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.location?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Notes</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>
          </>
        )}
        {interviewRoundInfo.interview?.interviewType == 'FACE_TO_FACE' &&
          !isSingleOrBulk && (
            <div>
              <MainFlex>
                <AdjustIcon>
                  <ConnectionIcon />
                </AdjustIcon>
                <InterviwerFlex column>
                  <CollageDetailsFlex spaceBetween centerVertically>
                    <Flex alignCenter>
                      <AntdAvatar
                        size={36}
                        IconName={candidateInfoData?.student?.firstName?.charAt(
                          0
                        )}
                      />

                      <CollageNameFlex>
                        <CollegeNameDiv>
                          {candidateInfoData?.student?.firstName}{' '}
                          {candidateInfoData?.student?.lastName}
                        </CollegeNameDiv>
                        {}
                        {}
                      </CollageNameFlex>
                    </Flex>
                  </CollageDetailsFlex>
                </InterviwerFlex>
              </MainFlex>
              <DetailsTitleDiv>Details</DetailsTitleDiv>
              <RightFlex column>
                <LeftFlex>
                  <DetailsNameDiv>Date Scheduled</DetailsNameDiv>
                  <ContentDiv>
                    {dateArr?.map((item, index) => (
                      <span
                        key={index + 'dateScheduled'}
                        style={{
                          backgroundColor: '#f0f0f0',
                          padding: '5px 5px', // Adjust padding as needed
                          borderRadius: '5px', // Adjust border radius as needed
                          marginRight:
                            index !== dateArr?.length - 1 ? '5px' : '0',
                        }}
                      >
                        {moment(item).format('DD MMM, YYYY')}
                      </span>
                    ))}
                  </ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Time</DetailsNameDiv>
                  <ContentDiv>{firstTime + ' - ' + lastTime}</ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Mode</DetailsNameDiv>
                  <ContentDiv>
                    {interviewRoundInfo?.mode === 'EXTERNAL_LINK_1'
                      ? 'Google Meet'
                      : interviewRoundInfo?.mode === 'OFFLINE'
                      ? interviewRoundInfo?.mode?.toLowerCase()
                      : 'External Link'}
                  </ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Notes</DetailsNameDiv>{' '}
                  <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
                </LeftFlex>
              </RightFlex>
            </div>
          )}
        {(interviewRoundInfo?.interview?.interviewType == 'GROUP' ||
          interviewRoundInfo?.interview?.interviewType == 'FACE_TO_FACE') && (
          <div>
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Round Name</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.interview?.interviewRound}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Round Type</DetailsNameDiv>{' '}
                <ContentDiv>
                  {interviewRoundInfo?.interview?.interviewType ===
                  'FACE_TO_FACE'
                    ? 'Face to Face'
                    : interviewRoundInfo?.interview?.interviewType === 'GROUP'
                    ? 'Group Discussion'
                    : interviewRoundInfo.interview?.interviewType.toLowerCase()}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Date Scheduled</DetailsNameDiv>
                <ContentDiv>
                  {dateArr?.map((item, index) => (
                    <span
                      key={index + 'dateSchedule'}
                      style={{
                        backgroundColor: ' #f0f0f0',
                        padding: '5px 5px', // Adjust padding as needed
                        borderRadius: '5px', // Adjust border radius as needed
                        marginRight:
                          index !== dateArr?.length - 1 ? '5px' : '0',
                      }}
                    >
                      {moment(item).format('DD MMM, YYYY')}
                    </span>
                  ))}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Time</DetailsNameDiv>
                <ContentDiv>{firstTime + ' - ' + lastTime}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Duration</DetailsNameDiv>
                <ContentDiv>
                  {interviewValueInfo?.duration} Min(Each)
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewRoundInfo?.mode === 'OFFLINE'
                    ? interviewRoundInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>

              {interviewInfo?.location && (
                <LeftFlex>
                  <DetailsNameDiv>Location</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.location?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Interviewer</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.panel?.map((data, kIndex) => {
                    return (
                      <CollageDetailsFlex
                        spaceBetween
                        centerVertically
                        key={kIndex + 'profile'}
                      >
                        <Flex alignCenter>
                          <AntdAvatar size={36} src={data?.profilePicture} />
                        </Flex>
                      </CollageDetailsFlex>
                    )
                  })}
                </ContentDiv>
              </LeftFlex>
              {interviewRoundInfo?.linkAndPanel && (
                <LeftFlex>
                  <DetailsNameDiv>Panel</DetailsNameDiv>
                  <ContentDiv>
                    <LinkSpan>
                      {interviewRoundInfo?.linkAndPanel?.length || '0'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Notes</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>{' '}
          </div>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <Fragment>
        {interviewRoundInfo?.interview?.interviewType && (
          <FooterFlex flexEnd>
            <Button.Secondary
              width="88px"
              height="38px"
              text="Back to Edit"
              onClick={handleBack}
            />
            <Button.Primary
              width="95px"
              height="38px"
              text="Reschedule"
              onClick={handleConfirm}
              loading={isLoading}
            />
          </FooterFlex>
        )}
      </Fragment>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={'Reschedule'}
        placement="right"
        visible={preview}
        content={content()}
        footer={footer()}
        onClose={() => {}}
        closable
      />
      <ScheduledSuccessfully
        interviewType={interviewType}
        setPrivew={setPrivew}
        isSingleOrBulk={isSingleOrBulk}
        interviewInfo={interviewInfo}
        success={success}
        setSuccess={setSuccess}
        setNotification={setNotification}
        setCreateSlotDrawer={setCreateSlotDrawer}
        setCandidateInfo={setCandidateInfo}
        selectedRoundType={selectedRoundType}
      />
    </>
  )
}

export default ScheduleDetails
